import React from "react";

import InformationCircle from "@impero-com/common/img/information-circle.svg";
import { Section, Svg, Tooltip } from "@impero-com/ui";

import * as theme from "./DashboardCard.css";
export interface DashboardCardProps {
    title: string;
    showTooltip: boolean;
    tooltipText?: string;
    children: React.ReactNode;
}
export function DashboardCard({
    title,
    showTooltip = false,
    tooltipText = "",
    children,
}: DashboardCardProps) {
    return (
        <Section className={theme.wrapper}>
            <div className={theme.header}>
                <span>{title}</span>
                {showTooltip && (
                    <Tooltip title={tooltipText}>
                        <span>
                            <Svg
                                src={InformationCircle}
                                className={theme.infoIcon}
                            />
                        </span>
                    </Tooltip>
                )}
            </div>
            {children}
        </Section>
    );
}
